"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFormFieldError = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Form = require("../../../../domains/registration/onboarding/shared/styles/Form");

var StyledFormFieldError = (0, _styledComponents["default"])(_Form.FormFieldError).withConfig({
  displayName: "AckFieldstyled__StyledFormFieldError",
  componentId: "sc-1e5mr57-0"
})(["margin-top:8px;padding-left:calc(24px + 12px);"]);
exports.StyledFormFieldError = StyledFormFieldError;